"use client"

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import Link from 'next/link'
import CategorySectionHeader from '../category-section-header/category-section-header'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useCategory } from '@/src/context/category/category-context'
import '@/src/extensions/number'
import BaseError from '@/src/components/helpers/base-error/base-error'
import ImageFallback from '@/src/components/helpers/image-fallback/image-fallback'
import ScrollContent from '@/src/components/helpers/scroll-content/scroll-content'
import LoadingWeeklyTop from './loading-weekly-top/loading-weekly-top'

interface Props {
    title: string
}

export default function WeeklyTop(props: Props) {
    return <></>
    // TODO: Implementar Tops da semana.
    // const [weeklyTop, setWeeklyTop] = useState<WeeklyTopCard[]>([])
    // const [loading, setLoading] = useState<boolean>(true)
    // const [error, setError] = useState<string | null>(null)
    // const { merchantSummary: merchant } = useMerchant()
    // const { isOnSearch } = useCategory()

    // useEffect(() => {
    //     const fetchWeeklyTop = async () => {
    //         try {
    //             const response = await ProductService.getWeeklyTop()

    //             if (!response.success || !response.model)
    //                 setError(`Não foi possível obter os tops da semana. Erro: ${response.errorMessage}`)

    //             setWeeklyTop(response.model!)
    //         } catch (err) {
    //             if (err instanceof Error)
    //                 setError(err.message)
    //             else
    //                 setError("Erro desconhecido.")
    //         } finally {
    //             setLoading(false)
    //         }
    //     }

    //     fetchWeeklyTop()
    // }, [])

    // if (loading)
    //     return <LoadingWeeklyTop />

    // if (!loading && weeklyTop?.length <= 1)
    //     return <div>Não há nenhum top da semana.</div>

    // if (error)
    //     return <BaseError message={error} />

    // if (isOnSearch) return <></>

    // return (
    //     <section className={styles.container}>
    //         <CategorySectionHeader id={props.title} title={props.title} type='weeklyTop' />
    //         <ScrollContent>
    //             {
    //                 weeklyTop && weeklyTop.map((item, index) => (
    //                     <Link key={index} href={`/produto/${item.id}`} className={styles.card} scroll={false}>
    //                         <div className={styles.imageArea}>
    //                             <ImageFallback src={`https://files.menudino.com/cardapios/${merchant?.code}/${item.productDetailsExternalId}.jpg`} alt={item.title} className={styles.image} />
    //                         </div>
    //                         <p className={`${styles.itemTitle}`}>{item.title}</p>
    //                         <b className={`${styles.price}`}>{item.price.toLocalePrice()}</b>
    //                     </Link>
    //                 ))
    //             }
    //         </ScrollContent>
    //     </section>
    // )
}
